import React from "react";
import PropTypes from "prop-types";

import "./Card.css";

/**
 * HomePage uses a condensed version of the standard Card component
 */
export default class Card extends React.Component {
  
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
  }
  
  render() {
    
    const { className, children } = this.props;
    
    const classNames = [ "home-card" ];
    if (className !== undefined) {
      classNames.push(className);
    }
    
    return (
      <div className={classNames.join(" ")}>
        { children }
      </div>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/Card.js